'use client';
import { ILocationDropDown, ISmallArea, useTranslation } from '@/hook';
import { IRegion_SELL } from '@/types';
import { useState } from 'react';

import { Disclaimer, LocationMap } from '@/components/sell-car-form';
import { PinLocationBlue } from '../../../../../public/Images/Acquisition';
import styles from './styles.module.scss';
import Image from 'next/image';
import usegeolocation from '@/hook/use-geolocation';
import Typography from '@/components/shared/typography/typography.component';
import SylndrButton from '@/components/shared/Button/button-styled.component';

const LocationMapForm = ({
    formContent,
    formFunction,
    step,
    disclaimerText,
    region,
}: {
    region: IRegion_SELL;
    formContent: ILocationDropDown[];
    step: 'region';
    formFunction: (key: 'region', clickedItem: IRegion_SELL) => void;
    open: boolean;
    searchPlaceholder: string;
    intialValue: ISmallArea;
    disclaimerText: string;
}) => {
    const [currRegion, setCurrRegion] = useState<IRegion_SELL>(region);

    const { t } = useTranslation();

    const formFunctionBridgeWithoutClose = (
        key: 'region',
        clickedItem: IRegion_SELL
    ) => {
        setCurrRegion(clickedItem);
    };
    const handleConfirm = () => {
        formFunction('region', currRegion);
    };
    const { success } = usegeolocation();

    return (
        <div className={`${styles.container}`} id={'container_location'}>
            {disclaimerText !== '' && (
                <Disclaimer
                    variant={currRegion?.warehouse ? 'error' : 'warning'}
                    text={disclaimerText}
                />
            )}
            <div className={styles.map_container}>
                {!success && (
                    <Disclaimer
                        variant={'warning'}
                        text={t('locationRequired')}
                    />
                )}
                <LocationMap
                    region={region}
                    open={false}
                    formFunction={formFunctionBridgeWithoutClose}
                    regions={formContent}
                    step={step}
                />
            </div>

            <div className={styles.button_container}>
                <div className={styles.address_container}>
                    <div className={styles.address_container_pin}>
                        <Image
                            src={PinLocationBlue.src}
                            width={20}
                            height={20}
                            alt="address"
                        />
                    </div>
                    <div>
                        <Typography variant="body2SemiBold">
                            {t('address')}
                            {': '}
                        </Typography>
                        <Typography variant="caption">
                            {currRegion.address}
                        </Typography>
                    </div>
                </div>
                <SylndrButton
                    variant="primary"
                    style={{ height: '48px' }}
                    onClick={() => handleConfirm()}
                    disabled={!currRegion?.address}
                >
                    <Typography>{t('continue')}</Typography>
                </SylndrButton>
            </div>
        </div>
    );
};
export default LocationMapForm;
